import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";
import { toParagraphList } from "./utils";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  description: string;
};

export default function DescriptionViewer({
  className,
  style,
  description,
}: Props) {
  const paragraphList = toParagraphList(description);

  return (
    <div className={cx(styles.container, className)} style={style}>
      {paragraphList.map((paragraph, index) => (
        <p key={index}>
          {paragraph.map((inline, index) => {
            switch (inline.type) {
              case "text":
                return <span key={index}>{inline.text}</span>;
              case "link":
                return (
                  <a
                    key={index}
                    href={inline.text}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {inline.text}
                  </a>
                );
            }
          })}
        </p>
      ))}
    </div>
  );
}
